export enum ListingType {
  PUBLIC_LISTING = "public-listing",
  PRIVATE_LISTING = "private-listing",
}
